import React from 'react'
import type { AvailabilityDisplayKind } from './types'

const ICON_GREEN = '#1F7A3F'
const ICON_SOLD = '#374151'

type IconProps = {
  size?: number
  className?: string
}

export const IconAvailableCheck: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke={ICON_GREEN}
    strokeWidth="2.8"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden
  >
    <path d="M5 12.5l4.5 4.5L19 7.5" />
  </svg>
)

export const IconLimitedHourglass: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <path
      d="M5 22h14M5 2h14M17 22v-4.172a2 2 0 0 0-.586-1.414L12 12l-4.414 4.414A2 2 0 0 0 7 17.828V22M7 2v4.172a2 2 0 0 0 .586 1.414L12 12l4.414-4.414A2 2 0 0 0 17 6.172V2"
      stroke={ICON_GREEN}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export const IconContactMessage: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <path d="M4 5h16v11H7l-3 3V5z" stroke={ICON_GREEN} strokeWidth="2" strokeLinejoin="round" />
    <path d="M8 9h8M8 12.5h5" stroke={ICON_GREEN} strokeWidth="2" strokeLinecap="round" />
  </svg>
)

export const IconSoldOutDash: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" className={className} aria-hidden>
    <path d="M5 12h14" stroke={ICON_SOLD} strokeWidth="2.2" strokeLinecap="round" />
  </svg>
)

export const IconUnknownDash: React.FC<IconProps> = ({ size = 18, className }) => (
  <svg width={size} height={size} viewBox="0 0 14 14" fill="none" className={className} aria-hidden>
    <rect x="1" y="6.2" width="12" height="3" fill="#E5E7EB" />
  </svg>
)

type AvailabilityStatusIconProps = IconProps & {
  kind: AvailabilityDisplayKind
}

export const AvailabilityStatusIcon: React.FC<AvailabilityStatusIconProps> = ({ kind, size, className }) => {
  switch (kind) {
    case 'available':
      return <IconAvailableCheck size={size} className={className} />
    case 'limited':
      return <IconLimitedHourglass size={size} className={className} />
    case 'contact':
      return <IconContactMessage size={size} className={className} />
    case 'sold_out':
      return <IconSoldOutDash size={size} className={className} />
    default:
      return <IconUnknownDash size={size} className={className} />
  }
}
